import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { tap } from "rxjs/operators";
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

const jwt = new JwtHelperService();
@Injectable({
  providedIn: "root",
})
export class AuthService {

  private readonly userSubject = new BehaviorSubject<any>(null);
  private baseUrl = `${environment.apiAuth}/auth`;
  private baseUrl2 = `${environment.apiUrl}/AcceptTerms`;
  private baseUrl3 = `${environment.apiAuth}/account`;
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  private apiUrl = environment.apiUrlAccessServices;
  private apiKey = environment.apiUrlAccessServicesToken;
  

  private get tokenKey(): string { return 'cp_tkn_x'; }
  private get userKey(): string { return 'cp_usr_x'; }

  get user(): any {
    return JSON.parse(window.localStorage.getItem(this.userKey));
  }

  set user(user) {
    if (user?.claims) {
      Object.entries(user.claims).forEach(x => user[x[0]] = x[1]);
    }
    window.localStorage.setItem(this.userKey, JSON.stringify(user));
    this.userSubject.next(user);
  }

  get token() {
    return window.localStorage.getItem(this.tokenKey);
  }

  set token(token: string) {
    window.localStorage.setItem(this.tokenKey, token);
  }

  get user$(): BehaviorSubject<any> {
    return this.userSubject;
  }

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.decodeAndNotify();
  }

  exchangeCodeForToken(code: string) {
    const body = new HttpParams()
      .set('client_id', 'hub')
      .set('grant_type', 'authorization_code')
      .set('code', code)
      .set('redirect_uri', `${window.location.origin}/auth/login`); // a mesma da chamada /auth

    return this.http.post(
      environment.keyCloakExchangeCodeUrl,
      body.toString(),
      { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') }
    );
  }

  getSsoConfiguration() {
    return this.http
      .get<any>(`${this.apiUrl}/config`, {
        headers: {
          'x-api-key': this.apiKey   // coloque aqui sua key
        }
      });
  }

  checkUserByEmailHub(email: string): Observable<{ document: string | null }> {
    const encodedEmail = encodeURIComponent(email);
    const url = `${this.apiUrl}/user-exists-by-email-hub/${encodedEmail}`;
    return this.http.get<{ document: string | null }>(url, {
        headers: {
          'x-api-key': this.apiKey   // coloque aqui sua key
        }
      });
  }

  loginWithKeycloakTokens(accessToken: string, cpf: string, codEmpresas: string[]): Observable<any> {
    const body = {
      token: accessToken,
      cpf: cpf,
      codEmpresas: codEmpresas,
      systemName: 'hub'
    };

    return this.http.post<any>(`${this.apiUrl}/sync`, body, {
        headers: {
          'x-api-key': this.apiKey   // coloque aqui sua key
        }
      });
  }

  authenticateToken(body) {
    return this.http
      .post<any>(this.baseUrl + '/SignIn', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  authenticateTokenExternal(idToken) {
    let body = {
      tokenId: idToken
    }

    return this.http
      .post<any>(this.baseUrl + '/SignInExtenal', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  authenticateTokenAD(body) {
    return this.http
      .post<any>(this.baseUrl + '/SignInAD', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  authenticate(body, token) {
    this.headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Accept': '*'
    })
    return this.http
      .post<any>(this.baseUrl + '/LoginUser', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  forgotPassword(body) {
    return this.http
      .post<any>(this.baseUrl3 + '/forgotPassword', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  changePassword(body) {
    return this.http
      .post<any>(this.baseUrl3 + '/changePassword/offline', body, { headers: this.headers, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  loginStepTwo(body) {
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + window.localStorage.getItem('cp_tkn_x'),
      'Accept': '*'
    })
    return this.http
      .post<any>(this.baseUrl + '/LoginStepTwo', body, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  loginStepThree(body) {
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + window.localStorage.getItem('cp_tkn_x'),
      'Accept': '*'
    })
    return this.http
      .post<any>(this.baseUrl + '/LoginStepThree', body, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  registerAccept(body, token) {
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Accept': '*'
    })
    return this.http
      .post<any>(this.baseUrl2 + '/RegisterAccept', body, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  getActiveTerm(body, token) {
    let termType;

    if (body.isProviderValue) {
      termType = 1;
    } else if (body.isBrokerValue) {
      termType = 2;
    }
    else {
      termType = 0;
    }
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Accept': '*'
    })
    return this.http
      .get<any>(this.baseUrl2 + '/GetActiveTerm/' + body.companyId + "/" + body.personId + "/termType?termType=" + termType, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  getCompanyTermList(id, token) {
    let header = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Accept': '*'
    })
    return this.http
      .get<any>(this.baseUrl2 + '/CompanyTermList/' + id, { headers: header, observe: 'response' })
      .pipe(
        tap(res => {
        })
      ).toPromise();
  }

  hasToken() {
    return !!this.token;
  }

  isLogged() {
    const isExpired = this.isExpired();
    const token = this.hasToken();
    if (!token || isExpired) {
      console.warn(!token ? `Usuário não autenticado.` : `Token expirado, redirecionando para login...`);
      this.removeUser();
      return false;
    }
    return token && !isExpired;
  }

  logout() {
    window.localStorage.clear();
    this.removeUser();
    this.router.navigate(["/auth/login"]);
  }

  private decodeAndNotify() {
    const user = JSON.parse(window.localStorage.getItem(this.userKey));
    if (!user) {
      // const token = this.getDecodedToken();
      //   this.getUserById(token.id).subscribe(user => {
      //     this.setUser(user);
      //   });
    } else this.user = user;
  }

  removeUser() {
    window.localStorage.clear();
    this.userSubject.next(null);
  }

  getDecodedToken() {
    return jwt.decodeToken(this.token);
  }

  isExpired() {
    return jwt.isTokenExpired(this.token);
  }

  removeToken() {
    window.localStorage.removeItem(this.tokenKey);
  }

  async createToken(payload: any): Promise<string> {
    return this.http
      .post(this.baseUrl + '/CreateToken', payload, {
        headers: this.headers,
        observe: 'body', // Mudando para 'body' para capturar diretamente o conteúdo
        responseType: 'text' // Garantindo que a resposta seja interpretada como texto
      })
      .toPromise()
      .then(response => {
        return response; // A resposta já é um token em string
      })
      .catch(error => {
        console.error("Erro na requisição:", error);
        throw error;
      });
  }

  signInAdv2(body: object) {
    return this.http.post<any>(this.baseUrl + '/SignInADV2/', body, {
      headers: this.headers,
      observe: 'response',
    }).pipe(
      tap(res => {
        // Log da resposta se necessário
      })
    );
  }
}
